import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploader } from 'ng2-file-upload';
import { APP_CONTS } from '../../../app.constants';
import { ImageResizeService } from './../../../services/image-resize.service';
import {ToastsManager} from 'ng2-toastr';
import {Certificacion} from '../../../../model/class/Certificacion';
import {CertificacionesService} from '../../../services/certificaciones/certificaciones.service';

@Component({
  selector: 'app-crear-certificaciones',
  templateUrl: './crear-certificaciones.component.html',
  styleUrls: ['./crear-certificaciones.component.css']
})
export class CrearCertificacionesComponent implements OnInit {

  @Input() newCerti: Certificacion;

  editando = false;
  loaders = {
    form: false,
    image: false
  };

  imageFormat = APP_CONTS.FILES.IMAGE_FORMAT_STR;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType:  APP_CONTS.FILES.IMAGE_FORMAT
  });

  constructor(
    public activeModal: NgbActiveModal,
    private imageResizeService: ImageResizeService,
    private toasts: ToastsManager,
    private certificacionesService: CertificacionesService,
  ) { }

  ngOnInit() {
    if (this.newCerti.id) {
      this.editando = true;
    }
  }

  asigneImage(event: any) {
    if (this.uploader.queue[0]) {
      const file = this.uploader.queue[0]._file;
      if (file) {
        this.loaders.image = true;
        this.newCerti.nuevaImagen = file;
        this.imageResizeService.resize([file], 500, 200)
          .subscribe((result) => {
            this.loaders.image = false;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.newCerti.imagen = e.target.result;
            };
            reader.readAsDataURL(result);
          });
      }
    } else {
      console.log('Archivo no valido');
    }
    this.uploader.queue = [];
  }

  onSubmit() {
    this.loaders.form = true;
    if (this.editando) {
      this.certificacionesService.edit(this.newCerti.id, this.newCerti.getFormData())
        .subscribe(
          (data) => {
            this.loaders.form = false;
            this.toasts.success(`La Certificación a sido modificada exitosamente.`);
            this.activeModal.close(data.data);
          }, (error) => {
            this.loaders.form = false;
            this.toasts.error(`Ha ocurrido un error al modificar la Certificación.`);
          }
        );

    } else {
      console.log('Creao!');
      const objCertificacion = new Certificacion(this.newCerti);
      this.certificacionesService.create(objCertificacion.getFormData())
        .subscribe(
          (data) => {
            this.loaders.form = false;
            this.toasts.success(`La Certificación a sido creada exitosamente.`);
            this.activeModal.close(data.data);
          }, (error) => {
            this.loaders.form = false;
            this.toasts.error(`Ha ocurrido un error al crear la Certificación.`);
          }
        );

    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/crear-certificaciones/crear-certificaciones.component.ts